import React from 'react';

import Gridview from '../../../elements/Gridview';
import { displayId, displayNumber, displayDate } from '../../../core/utils/helpers';

export default function () {
    const { products, total, page, isFetching } = this.props;

    const renderAverageQuantity = value => (value ? parseFloat(value).toFixed(2) : '-');

    const config = [
        { dataIndex: 'sku', title: 'Product Code', render: value => displayId(value.toString()) },
        { dataIndex: 'title', title: 'Product Name' },
        { dataIndex: 'description', title: 'Description' },
        { dataIndex: 'average_quantity', title: 'Avg Quantity', className: 'text-center', render: renderAverageQuantity },
        { dataIndex: 'times_ordered', title: 'Times Ordered', className: 'text-center', render: displayNumber },
        { dataIndex: 'first_ordered', title: 'First Ordered', render: value => displayDate(value) },
        { dataIndex: 'last_ordered', title: 'Last Ordered', render: value => displayDate(value) },
    ];

    return (
        <Gridview
            config={config}
            data={products}
            loading={isFetching}
            title="Clients Products Usage"
            pagination={{
                simple: true,
                onChange: this.handlePagination,
                pageSize: 10,
                total,
                current: page,
                className: 'custom-pagination',
            }} />
    );
}
